export default "__VITE_ASSET__BPASuZWX__"